import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, notification, Space, Tabs } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TickerSearch from '../../modules/Search/TickerSearch/TickerSearch';
import PortfolioSearch from '../../modules/Search/PortfolioSearch/PortfolioSearch';
import { fetchDetailedPortfolioObjects } from "../../api/portfolioApi";
import { selectFullPortfolios } from "../../store/slices/portfolios.slice";
import XrayPortfolios from "./XrayPortfolios";
import NavTrail from "../../layouts/NavTrail";
import {AddRounded} from "@mui/icons-material";

const { TabPane } = Tabs;

const MultiSearchContainer = ({
                                  onTickersSubmit, tickerTypes, tickerSearchProps,
                                  onPortfoliosSubmit, portfolioSearchProps,
                                  tabExtra
                              })=>{

    return (
        <Card bordered={false} className={'shadow-lg'} style={{maxWidth: 1000, margin: 'auto'}}>
            <Tabs centered={true} tabBarExtraContent={tabExtra}>
                <TabPane tab={'Tickers'} key={'tickers'}>
                    <TickerSearch types={tickerTypes} onTickersSubmit={onTickersSubmit} {...tickerSearchProps} />
                </TabPane>
                <TabPane tab={'Portfolios'} key={'portfolios'}>
                    <PortfolioSearch onSelect={onPortfoliosSubmit} {...portfolioSearchProps} />
                </TabPane>
            </Tabs>
        </Card>
    )
}


const Xray = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();
    const [view, setView] = useState('select');
    const [config, setConfig] = useState({
        wrap: false
    })
    const [portfolioIds, setPortfolioIds] = useState([]);
    const [etfIds, setEtfIds] = useState([]);
    const fullPortfolioObjects = useSelector(state => selectFullPortfolios(state, portfolioIds));
    const trailItems = [
        {label: "X-Ray", path: "/beta/xray"}
    ]
    // Handle portfolio selection from PortfolioSelector
    const handlePortfolioSelection = (selectedPortfolios) => {
        const selectedIds = selectedPortfolios.map(p => p.id);
        setPortfolioIds(prevIds=>[...prevIds, ...selectedIds]);
        if (selectedIds.length > 0) {
            fetchPortfolios(selectedIds);
        }
    };


    const handleNavPerformanceComparison = ()=>{
        const allIds = [...portfolioIds, ...etfIds];
        const url = `/performance/comparison?ids=${allIds.join(',')}`;
        navigate(url);
    }

    const afterSubmit = ()=>{
        api.success({
            message: 'Items Added',
            description: 'You can either view the X-Ray or keep searching',
            btn: (
                <Space>
                    <Button onClick={()=>{
                        setView('xray');
                        api.destroy()
                    }}>
                        View X-Ray
                    </Button>
                    <Button onClick={()=>api.destroy()}>
                        Keep Searching
                    </Button>
                </Space>
            )
        })
    }

    const handleEtfSelection = (selectedEtfs) => {
        setEtfIds(prevIds=>[...prevIds, ...selectedEtfs.map(x=>x.symbol)]);
        afterSubmit()
    }



    // Fetch detailed portfolio data
    const fetchPortfolios = async (ids) => {
        try {
            await dispatch(fetchDetailedPortfolioObjects(ids));
            afterSubmit()

        } catch (error) {
            console.error('Error fetching portfolio details:', error);
            // You might want to add error handling UI here
        }
    };



    const reformatSymbols = (symbols)=>{
        const newObj = {};
        Object.keys(symbols).forEach((key)=>{
            newObj[key] = {wgt: symbols[key]}
        });
        return newObj;
    }
    // Render different views based on state
    const renderContent = () => {
        switch (view) {
            case 'select':
                return (
                    <MultiSearchContainer onTickersSubmit={handleEtfSelection}
                                          tickerTypes={['etf']}
                                          onPortfoliosSubmit={handlePortfolioSelection}
                                          portfolioSearchProps={{maxRows: 20}}
                    />
                );
            case 'xray':
                return fullPortfolioObjects ? (
                    <div>
                        <ButtonGroup className={'pl-6'}>
                                <Button startIcon={<AddRounded/>}
                                        onClick={()=>setView('select')}
                                >
                                    Add Portfolios
                                </Button>
                                <Button onClick={
                                    ()=>setConfig(prevConfig=>({...prevConfig, wrap: !prevConfig.wrap}))
                                }>
                                    {config.wrap ? "Flatten Rows" : "Wrap Rows"}
                                </Button>
                                <Button onClick={handleNavPerformanceComparison}>
                                    Performance Comparison
                                </Button>
                        </ButtonGroup>
                        <XrayPortfolios
                            portfolios={[
                                ...fullPortfolioObjects.map(x=>({
                                    name: x.name,
                                    ptfl: reformatSymbols(x.symbols),
                                    key: x.id
                                })),
                                ...etfIds.map(x=>({
                                    name: x,
                                    ptfl: {
                                        [x]: {wgt: 1}
                                    },
                                    key: x
                                }))
                            ]}
                            onBack={() => setView('select')}
                            onRemove={(key) => {
                                if (etfIds.includes(key)) setEtfIds(prevIds=>prevIds.filter(id=>id!==key));
                                else setPortfolioIds(prevIds=>prevIds.filter(id=>id!==key));
                            }}
                            wrap={config.wrap}
                        />
                    </div>
                ) : (
                    <div className="flex justify-center items-center h-32">
                        Loading portfolio data...
                    </div>
                );
            default:
                return null;
        }
    };
    return (
        <div className={'px-4'}>
            <NavTrail items={trailItems} />
            <div className="py-4">
                {contextHolder}
                {renderContent()}
            </div>
        </div>
    );
};

export default Xray;